import { render, staticRenderFns } from "./TableCellCheckpoints.vue?vue&type=template&id=10196a98&"
import script from "./TableCellCheckpoints.vue?vue&type=script&lang=ts&"
export * from "./TableCellCheckpoints.vue?vue&type=script&lang=ts&"
import style0 from "./TableCellCheckpoints.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports